export const CheckMark = () => {
	return (
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="8" cy="8" r="8" fill="#0D4DA1" fillOpacity="0.11" />
			<path fillRule="evenodd" clipRule="evenodd" d="M11.9578 3.23513L5.98951 9.15549L4.40573 7.41622C4.11398 7.13348 3.65552 7.11635 3.32209 7.35625C2.997 7.60471 2.90531 8.04167 3.10537 8.39295L4.98089 11.5288C5.16428 11.8201 5.48103 12 5.83946 12C6.18123 12 6.50632 11.8201 6.6897 11.5288C6.98979 11.1261 12.7164 4.10905 12.7164 4.10905C13.4666 3.32081 12.558 2.62682 11.9578 3.22656V3.23513Z" fill="#12B76A" fillOpacity="0.6" />
		</svg>

	)
}